import React from 'react';
import unescape from 'lodash/unescape';
import JwPlayer from './JwPlayer';
import Laola from './Laola';
import Livestream from './Livestream';
import Ooyala from './Ooyala';
import Piksel from './Piksel';
import Wistia from './Wistia';
import Wowza from './Wowza';
import Brightcove from './Brightcove';
import Kaltura from './Kaltura';
import Qbrick from './Qbrick';

export default (host, content, asset = null, options = null) => {
    let json = '';

    if (content !== '' && content !== null && content !== undefined) {
        if (host !== 'piksel') {
            try {
                json = JSON.parse(unescape(content));
            } catch (e) {}
        } else {
            json = content;
        }
    }

    switch (host) {
        case 'jwplayer':
            return <JwPlayer content={json} options={options} />;
        case 'laola':
            return <Laola content={json} options={options} />;
        case 'livestream':
            return <Livestream content={json} options={options} />;
        case 'ooyala':
            return <Ooyala content={json} options={options} />;
        case 'piksel':
            return <Piksel content={json} options={options} />;
        case 'wistia':
            return <Wistia content={json} options={options} />;
        case 'wowza':
            return <Wowza content={json} options={options} />;
        case 'brightcove':
            return <Brightcove content={json} assetId={asset.id} />;
        case 'kaltura':
            return <Kaltura content={json} options={options} />;
        case 'qbrick':
            return <Qbrick content={json} options={options} />;
    }
};



// WEBPACK FOOTER //
// ./src/containers/Asset/ContentInjectors/Ovp/factory.js